<template>
  <div class="editor-additional__edit-wrapper">
    <EditorEditButton icon="editor/delete" @click="emit('delete')" />
  </div>
</template>

<script setup>
const emit = defineEmits(['delete']);
</script>
